// A rabbit, modelled facing +X (its nose points along +X): a rounded body, a
// head, two upright ears and a fluffy white tail. Ported 1:1 from age-of-mcp's
// classic rabbit.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.045, 0),
      color: "#cfb88a", position: [0, 0.045, 0], scale: [1.25, 1, 1] },
    { geometry: new THREE.IcosahedronGeometry(0.028, 0),
      color: "#e0caa0", position: [0.048, 0.064, 0] },
    { geometry: new THREE.BoxGeometry(0.011, 0.042, 0.007),
      color: "#cfb88a", position: [0.045, 0.1, 0.013], rotation: [0, 0, -0.2] },
    { geometry: new THREE.BoxGeometry(0.011, 0.042, 0.007),
      color: "#cfb88a", position: [0.045, 0.1, -0.013], rotation: [0, 0, -0.2] },
    { geometry: new THREE.IcosahedronGeometry(0.016, 0),
      color: "#ffffff", position: [-0.046, 0.046, 0] },
  ];
}

export const rabbit = defineModel({
  id: "rabbit",
  batchId: "standard",
  name: "Rabbit",
  tags: ["creature","rabbit","low-poly","age-of-mcp","classic"],
  summary: "Low-poly rabbit.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.07,
  parts: () => partsFor(),
  animations: [],
});
